import React from "react";
import { Route } from "react-router-dom";
import lazyWithRetry from "@shared/utils/lazyWithRetry";

// Lazy loading de páginas públicas con retry automático
const LoginPage = lazyWithRetry(
  () => import("@features/auth/ui/LoginPage"),
  "LoginPage",
);
const SignupPage = lazyWithRetry(
  () => import("@features/auth/ui/SignupPage"),
  "SignupPage",
);
const WelcomePage = lazyWithRetry(
  () => import("@features/landing/ui/pages/WelcomePage"),
  "WelcomePage",
);
const PrivacyAndTermsPage = lazyWithRetry(
  () => import("@features/legal/ui/pages/PrivacyAndTermsPage"),
  "PrivacyAndTermsPage",
);
const ForgotPasswordPage = lazyWithRetry(
  () => import("@features/password-recovery/ui/pages/ForgotPasswordPage"),
  "ForgotPasswordPage",
);
const ConfirmValidateSignaturePage = lazyWithRetry(
  () =>
    import("@features/digital-signature/ui/pages/ConfirmValidateSignaturePage"),
  "ConfirmValidateSignaturePage",
);
const RejectValidateSignaturePage = lazyWithRetry(
  () =>
    import("@features/digital-signature/ui/pages/RejectValidateSignaturePage"),
  "RejectValidateSignaturePage",
);
const NotFoundPage = lazyWithRetry(
  () => import("@features/landing/ui/pages/NotFoundPage"),
  "NotFoundPage",
);

/**
 * Rutas públicas - no requieren autenticación
 */
export const publicRoutes = [
  <Route key="login" path="/" element={<LoginPage />} />,
  <Route key="signup" path="/signup" element={<SignupPage />} />,
  <Route key="welcome" path="/bienvenida" element={<WelcomePage />} />,
  <Route
    key="privacy"
    path="/privacy-policy&terms-of-service"
    element={<PrivacyAndTermsPage />}
  />,
  <Route
    key="forgot-password"
    path="/forgot-password"
    element={<ForgotPasswordPage />}
  />,
  <Route
    key="confirm-signature"
    path="/confirm-validate-signature"
    element={<ConfirmValidateSignaturePage />}
  />,
  <Route
    key="reject-signature"
    path="/reject-validate-signature"
    element={<RejectValidateSignaturePage />}
  />,
  <Route key="not-found" path="*" element={<NotFoundPage />} />,
];

export default publicRoutes;
